var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tip-dialog" },
    [
      _c("div", { staticClass: "tip-dialog-header" }, [
        _c(
          "div",
          { staticClass: "tip-dialog-header-tabs" },
          _vm._l(_vm.tabItems, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "tabs-item",
                  _vm.currentTabIndex === index ? "active" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.handleTabItemClick(index)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item) + " ")]
            )
          }),
          0
        ),
        _c("div", { staticClass: "tip-dialog-options" }, [
          _vm.loadType === "custom"
            ? _c(
                "div",
                {
                  staticClass: "create-template-btn",
                  on: { click: _vm.handleCreateClick },
                },
                [_vm._v(" 创建模板 ")]
              )
            : _vm._e(),
          _c("i", {
            staticClass: "el-icon-close close-icon",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "template-content" },
        [
          _vm.currentTabIndex === 0
            ? _c(
                "div",
                { staticClass: "type-tags" },
                _vm._l(_vm.tagItems, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "tag",
                      class: { active: index === _vm.currentTagIndex },
                      on: {
                        click: function ($event) {
                          return _vm.handleTagClick(index)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.classifyName) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.templateList.length
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "infinite-scroll",
                      rawName: "v-infinite-scroll",
                      value: _vm.load,
                      expression: "load",
                    },
                  ],
                  ref: "templateListRef",
                  staticClass: "type-template-content",
                  style: {
                    height:
                      _vm.currentTabIndex === 0
                        ? "calc(100% - 48.16px - 20px - 30px)"
                        : "calc(100% - 48.16px)",
                  },
                },
                [
                  _vm._l(_vm.templateList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "type-template-content-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleTemplateClick(item)
                          },
                          mouseenter: function ($event) {
                            return _vm.templateMouseEnter(item, index)
                          },
                          mouseleave: function ($event) {
                            item.isShowOption = item.unfold
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "template-title" }, [
                          _vm._v(_vm._s(item.templateTitle)),
                        ]),
                        _c(
                          "p",
                          {
                            ref: "contentRef",
                            refInFor: true,
                            staticClass: "template-content-text",
                            class: {
                              unfold: !item.unfold,
                            },
                          },
                          [_vm._v(" " + _vm._s(item.content) + " ")]
                        ),
                        item.isShowOption && _vm.loadType === "custom"
                          ? _c("div", { staticClass: "template-operation" }, [
                              item.isShowZhanKai
                                ? _c(
                                    "div",
                                    { staticClass: "icon" },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "zhankai-icon",
                                        attrs: { "icon-class": "zhankai" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleZhanKaiClick(
                                              item,
                                              index
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tip",
                                          staticStyle: { left: "-9px" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.unfold ? "折叠" : "展开"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !item.isCollection
                                ? _c(
                                    "div",
                                    { staticClass: "icon" },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "edit-icon",
                                        attrs: { "icon-class": "_edit" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditClick(
                                              item,
                                              "user"
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tip",
                                          staticStyle: { left: "-9px" },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !item.isCollection
                                ? _c(
                                    "div",
                                    { staticClass: "icon" },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "delete-icon",
                                        attrs: { "icon-class": "_delete" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDeleteClick(item)
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tip",
                                          staticStyle: { left: "-9px" },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        item.isShowOption && _vm.loadType === "system"
                          ? _c("div", { staticClass: "template-operation" }, [
                              _c(
                                "div",
                                { staticClass: "icon" },
                                [
                                  item.isLiked
                                    ? _c("svg-icon", {
                                        attrs: {
                                          "icon-class": "dianzan-active",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDianZanClick(item)
                                          },
                                        },
                                      })
                                    : _c("svg-icon", {
                                        staticClass: "dianzan-icon",
                                        attrs: { "icon-class": "dianzan" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDianZanClick(item)
                                          },
                                        },
                                      }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tip",
                                      staticStyle: { left: "-9px" },
                                    },
                                    [_vm._v("点赞")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "icon" },
                                [
                                  item.isCollection
                                    ? _c("svg-icon", {
                                        attrs: {
                                          "icon-class": "shoucang-active",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShouCangClick(item)
                                          },
                                        },
                                      })
                                    : _c("svg-icon", {
                                        staticClass: "shoucang-icon",
                                        attrs: { "icon-class": "shoucang" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShouCangClick(item)
                                          },
                                        },
                                      }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tip",
                                      staticStyle: { left: "-9px" },
                                    },
                                    [_vm._v("收藏")]
                                  ),
                                ],
                                1
                              ),
                              item.isShowZhanKai
                                ? _c(
                                    "div",
                                    { staticClass: "icon" },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "zhankai-icon",
                                        attrs: { "icon-class": "zhankai" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleZhanKaiClick(
                                              item,
                                              index
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tip",
                                          staticStyle: { left: "-9px" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.unfold ? "折叠" : "展开"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "loading-box" },
                        [
                          _c("svg-icon", {
                            staticClass: "loading-icon",
                            attrs: { "icon-class": "_loading" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          !_vm.templateList.length && !_vm.loading
            ? [
                _c("div", { staticClass: "empty" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/image/aiIcon.gif") },
                  }),
                  _c("span", [
                    _vm._v(
                      "暂未创建" +
                        _vm._s(
                          _vm.loadType === "system" ? "系统默认" : "我的"
                        ) +
                        "模板"
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("CreateUpdateDialog", {
        ref: "createUpdateDialogRef",
        attrs: { "dialog-show": _vm.showCreateOrUpdateDialog },
        on: {
          "update:dialogShow": function ($event) {
            _vm.showCreateOrUpdateDialog = $event
          },
          "update:dialog-show": function ($event) {
            _vm.showCreateOrUpdateDialog = $event
          },
          "updata:dialogShow": function ($event) {
            _vm.showCreateOrUpdateDialog = $event
          },
          update: function ($event) {
            return _vm.getTemplateList(_vm.pageParams)
          },
        },
      }),
      _vm.showCreateOrUpdateDialog
        ? _c("div", { staticClass: "mask" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }